var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivide02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28631 14.714L14.7144 5.28595M7.64333 5.28595C8.29421 5.93683 8.29421 6.9921 7.64333 7.64298C6.99246 8.29385 5.93718 8.29385 5.28631 7.64298C4.63544 6.9921 4.63544 5.93683 5.28631 5.28595C5.93718 4.63508 6.99246 4.63508 7.64333 5.28595ZM14.7144 12.357C15.3653 13.0079 15.3653 14.0632 14.7144 14.714C14.0635 15.3649 13.0083 15.3649 12.3574 14.714C11.7065 14.0632 11.7065 13.0079 12.3574 12.357C13.0083 11.7061 14.0635 11.7061 14.7144 12.357Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivide02);
export default __webpack_public_path__ + "static/media/divide-02.af51fecf0055b073537728e50d78ad46.svg";
export { ForwardRef as ReactComponent };